import { render, staticRenderFns } from "./BroadcastView.vue?vue&type=template&id=28b7b66a&scoped=true&"
import script from "./BroadcastView.vue?vue&type=script&lang=js&"
export * from "./BroadcastView.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastView.vue?vue&type=style&index=0&id=28b7b66a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b7b66a",
  null
  
)

export default component.exports